
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","d":"M10 17.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill":"currentColor","d":"M10 15a.937.937 0 100-1.875A.937.937 0 0010 15z"}}),_c('path',{attrs:{"stroke":"currentColor","d":"M10 11.25v-.624a2.188 2.188 0 10-2.188-2.188","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/lk/img/Question.svg